import Vue from 'vue';
import { mapGetters } from 'vuex';
import InlineText from '@editor/droplets/_bubble-options/components/inline-text';
import * as clipboard from 'clipboard-polyfill/dist/clipboard-polyfill.promise';

export default Vue.component('card-item', {
  template: require('./template.html'),
  components: {
    InlineText,
  },
  computed: {
    ...mapGetters(['currentPage', 'viewport', 'activeDropletItem']),
    titleWarning() {
      let color = '';
      if (this.titleCount > this.titleLimit - 10) {
        color = '#ff5f5f';
      }
      return color;
    },
    bodyWarning() {
      let color = '';
      if (this.textCount > this.textLimit - 10) {
        color = '#ff5f5f';
      }
      return color;
    },
  },
  data() {
    return {
      activetitleCard: null,
      activetextCard: null,
      titleCount: null,
      textCount: null,
      titleLimit: 50,
      textLimit: 160,
      typing: false,
      pasteTO: null,
      toolbar: [
        {
          type: 'bold',
          tip: 'Bold',
        },
        {
          type: 'italic',
          tip: 'Italic',
        },
        {
          type: 'underline',
          tip: 'Underline',
        },
        {
          type: 'fontSize',
          tip: 'Font Size',
          sizes: ['8', '9', '10', '11', '12', '14', '16', '24', '36'],
        },
        {
          type: 'fontName',
          tip: 'Font',
          fonts: [
            'Arial',
            'Arial Black',
            'Comic Sans MS',
            'Courier New',
            'Impact',
            'Lucida Console',
            'Source Sans Pro',
            'Times New Roman',
            'Verdana',
          ],
        },
        {
          type: 'foreColor',
          tip: 'Font Color',
          colors: [
            '#ffffff',
            '#cccccc',
            '#808080',
            '#343434',
            '#000000',
            '#C8E6C9',
            '#81C784',
            '#4CAF50',
            '#388E3C',
            '#1B5E20',
            '#B2EBF2',
            '#4DD0E1',
            '#00BCD4',
            '#0097A7',
            '#006064',
            '#BBDEFB',
            '#64B5F6',
            '#2196F3',
            '#1976D2',
            '#0D47A1',
            '#D1C4E9',
            '#9575CD',
            '#673AB7',
            '#512DA8',
            '#311B92',
            '#F8BBD0',
            '#F06292',
            '#E91E63',
            '#C2185B',
            '#880E4F',
            '#FFCDD2',
            '#E57373',
            '#F44336',
            '#D32F2F',
            '#B71C1C',
            '#FFE0B2',
            '#FFB74D',
            '#FF9800',
            '#F57C00',
            '#E65100',
            '#FFF9C4',
            '#FFF176',
            '#FFEB3B',
            '#FBC02D',
            '#F57F17',
          ],
        },
        {
          type: 'justifyLeft',
          tip: 'Justify Left',
        },
        {
          type: 'justifyCenter',
          tip: 'Justify Center',
        },
        {
          type: 'justifyRight',
          tip: 'Justify Right',
        },
        {
          type: 'createLink',
          tip: 'Link',
        },
      ],
    };
  },
  props: ['droplet', 'card', 'card-index', 'display'],
  name: 'card-item',
  methods: {
    emitOpenToolbar(v) {
      this.$emit('open-toolbar', v);
    },
    updateText(text, type) {
      this[`active${type}Card`] = null;
      this.typing = false;
      const payload = {};
      payload.drp = this.droplet;
      payload.cardIndex = this.cardIndex;
      payload.type = type;
      payload[type] = text.trim() === '' ? false : text;
      if (this.card[type] !== text) {
        this.$store.dispatch('setTallCardText', payload);
      }
    },
    inputText(e, type) {
      this[`active${type}Card`] = this.cardIndex;
      this.typing = true;
      this.charCount(e, type);
      const key = e.which;
      if (this[`${type}Count`] >= this[`${type}Limit`] && key !== 8) {
        e.preventDefault();
      }
    },
    pasteText(e, type) {
      this[`active${type}Card`] = this.cardIndex;
      this.typing = true;
      clipboard.readText().then((copy) => {
        copy = copy.length;
        this.charCount(e, type);
        // prevent users from pasting in copy longer than limit
        clearTimeout(this.pasteTO);
        if ((this[`${type}Count`] + copy) >= this[`${type}Limit`]) {
          e.preventDefault();
        } else {
          this.pasteTO = setTimeout(() => {
            this.charCount(e, type);
          }, 5);
        }
      })
        .catch(e => this.$log.error(e));
    },
    getDisplayShadow(_id) {
      const activeColumn = this.activeDropletItem;
      return (activeColumn && activeColumn._id === _id) || !activeColumn || !activeColumn._id;
    },
    charCount(e, type) {
      const val = e.target.innerText;
      this[`${type}Count`] = val.length;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-tall/components/card-item/index.js